import { addData } from "@/actions/auth";
import LandingLayout from "@/components/landing/home/LandingLayout";
import MainBanner from "@/components/landing/home/MainBanner";
import Head from "next/head";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

const Signup = () => {
    const dispatch = useDispatch();

    const isLogin = () => {
        const token = window.localStorage.getItem('token');
        if (token) {
            window.location.pathname = '/';
        } else {
            // dispatch(setData({
            //     name: 'creds',
            //     key: 'isLoggedIn',
            //     value: false,
            // }));
            dispatch(
                addData({
                    key: 'isLoggedIn',
                    value: false,
                })
            );
        }
    };

    useEffect(() => {
        isLogin();
    }, []);
    return (<>
        <Head>
            <link rel="canonical" href={`${process.env.NEXT_PUBLIC_SITE_URL}signup`} />
        </Head>
        <LandingLayout>
            <div className="ptb-100 login-content">
                <MainBanner backgroundColorWhite mission={""} isSignUpPage={true} />
            </div>
        </LandingLayout>
    </>
    )
}

export default Signup;